/* eslint-disable no-irregular-whitespace */
/**
U+2000    En Quad                &#8192;      " "
U+2001    Em Quad                &#8193;      " "
U+2002    En Space               &#8194;      " "
U+2003    Em Space               &#8195;      " "
U+2004    Three-Per-Em Space     &#8196;      " "
U+2005    Four-Per-Em Space      &#8197;      " "
U+2006    Six-Per-Em Space       &#8198;      " "
U+2007    Figure Space           &#8199;      " "
U+2008    Punctuation Space      &#8200;      " "
U+2009    Thin Space             &#8201;      " "
U+200A    Hair Space             &#8202;      " "
U+200B    Zero-Width Space       &#8203;      "​"
U+200C    Zero Width Non-Joiner  &#8204;      "‌"
U+200D    Zero Width Joiner      &#8205;      "‍"
U+200E    Left-To-Right Mark     &#8206;      "‎"
U+200F    Right-To-Left Mark     &#8207;      "‏"
U+202F    Narrow No-Break Space  &#8239;      " "
'\u2060', // Word Joiner
  '\u2061', // FUNCTION APPLICATION
  '\u2062', // INVISIBLE TIMES
  '\u2063', // INVISIBLE SEPARATOR
  '\u2064', // INVISIBLE PLUS
  '\u2066', // LEFT - TO - RIGHT ISOLATE
  '\u2067', // RIGHT - TO - LEFT ISOLATE
  '\u2068', // FIRST STRONG ISOLATE
  '\u2069', // POP DIRECTIONAL ISOLATE
  '\u206A', // INHIBIT SYMMETRIC SWAPPING
  '\u206B', // ACTIVATE SYMMETRIC SWAPPING
  '\u206C', // INHIBIT ARABIC FORM SHAPING
  '\u206D', // ACTIVATE ARABIC FORM SHAPING
  '\u206E', // NATIONAL DIGIT SHAPES
  '\u206F', // NOMINAL DIGIT SHAPES
  '\u200B', // Zero-Width Space
  '\u200C', // Zero Width Non-Joiner
  '\u200D', // Zero Width Joiner
  '\u200E', // Left-To-Right Mark
  '\u200F', // Right-To-Left Mark
  '\u061C', // Arabic Letter Mark
  '\uFEFF', // Byte Order Mark
  '\u180E', // Mongolian Vowel Separator
  '\u00AD'  // soft-hyphen
*/
/* eslint-enable no-irregular-whitespace */

const invisibleCharactersRegExp = /[\u2060-\u206F]|[\u2000-\u200F]|[\u061C\uFEFF\u180E\u00AD\u202F]/g;

const removeInvisibleCharacters = (s: string) => s.replace(invisibleCharactersRegExp, "");

export { removeInvisibleCharacters };
